import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IUserState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const userModule: Module<IUserState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default userModule
